(function () {
    angular.module('tmx-app').factory('OperationReportService', ['$http', 'APP_CONSTANTS', 'tmxResource', '$filter', '$q', 'tmxUtility', '$mdMedia', 'lookupService','cacheStore','TMX_FINANCE_CONSTANTS',
        function ($http, APP_CONSTANTS, tmxResource, $filter, $q, tmxUtility, $mdMedia, lookupService,cacheStore,TMX_FINANCE_CONSTANTS) {

            var Report = tmxResource("report");
            // Report.GetProductSkuByWarehouse = GetProductSkuByWarehouse;
            // Report.GetProductSkuByWarehouseId = GetProductSkuByWarehouseId;
            // Report.setLookups = setLookups;
            Report.exportOperationReport = exportOperationReport;
            
            var LoggedInUserConfigurations = cacheStore.get("Configurations");
            var tenants = TMX_FINANCE_CONSTANTS.TENANTS;
            var loggedInTenantName = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'INTEGRATION_TENANT').toLowerCase();
            var showComments = loggedInTenantName == tenants.VITAS;
            var showCreator = loggedInTenantName == tenants.VITAS;
            Report.showComments = showComments;
            Report.showCreator = showCreator;
            function exportOperationReport(loanapplicationnumber,branchid,nationalid,offset,fromdate,todate) {

                if(!loanapplicationnumber){
                    loanapplicationnumber=null;
                }

                if(!branchid){
                    branchid=null;
                }
                
                if(!nationalid){
                    nationalid=null;
                }

                if(!offset){
                    offset=null;
                }
                
                if(!fromdate){
                    fromdate=null;
                }

                if(!todate){
                    todate=null;
                }

                var objArgs = {
                    "LoanApplicationNumber":loanapplicationnumber,
                    "BranchId":branchid,
                    "NationalId":nationalid,
                    "offset":offset,
                    "FromDate":fromdate,
                    "ToDate":todate
                };

                var filters = {
                    "StoredProcedure": "sp_operation_report",
                    "Arguments": objArgs,
                    "ReportName": "Operation_Report",
                    "PageOrientation": "Landscape"
                };

                //var url = '/ExportLoanReport/' + userid + '/'+ deliveryManId + '/' + startdate + '/' + enddate + '/' + new Date().getTimezoneOffset();
                $http.post(APP_CONSTANTS.backend + 'report/ReportPDF' , filters , { responseType: 'arraybuffer' })
                    .success(function (data) {
                        var file = new Blob([data], { type: 'application/pdf' });
                        saveAs(file, 'OperationReport.pdf');
                    });
            }

            Report.GridColumns = [


                {
                    field: tmxUtility.formatColumnName('LoanApplicationNumber'),
                    title: "LoanApplicationNumber",
                    type: "integer",
                        //  width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template: "<span >{{dataItem[OperationReportCtrl.formatColumnName('LoanApplicationNumber')]}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>Loan Application #</span>"                        
                },
                {
                    field: tmxUtility.formatColumnName('clientname'),
                    title: "clientname",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template: "<span >{{dataItem[OperationReportCtrl.formatColumnName('clientname')]}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>Client Name</span>"
                },
                // {
                //     field: "NationalIdentifierValue",
                //     title: "NationalIdentifierValue",
                //     type: "text",
                //     // width: $mdMedia('gt-sm') ? '10%' : '150px',
                //     scrollable: false,
                //     search: true,
                //     headerTemplate: "<span>National ID Value</span>"
                // },
                // {
                //     field: "CreditRationale",
                //     title: "CreditRationale",
                //     type: "text",
                //     // width: $mdMedia('gt-sm') ? '10%' : '150px',
                //     scrollable: false,
                //     search: true,
                //     headerTemplate: "<span>Credit Rationale</span>"
                // },
                {
                    field: tmxUtility.formatColumnName('RequestedLoanAmount'),
                    title: "RequestedLoanAmount",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template: "<span >{{dataItem[OperationReportCtrl.formatColumnName('RequestedLoanAmount')]}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>Requested Amount</span>"
                },
                // {
                //     field: "RecommendedLoanAmount",
                //     title: "RecommendedLoanAmount",
                //     type: "text",
                //     // width: $mdMedia('gt-sm') ? '10%' : '150px',
                //     scrollable: false,
                //     search: true,
                //     headerTemplate: "<span>Approved Amount</span>"
                // },
                {
                    field: tmxUtility.formatColumnName('BranchName'),
                    title: "BranchName",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template: "<span >{{dataItem[OperationReportCtrl.formatColumnName('BranchName')]}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>Branch Name</span>"
                },
                ( showCreator &&  
                    {
                        field: "Creator",
                        title: "Creator",
                        type: "text",
                        // width: $mdMedia('gt-sm') ? '10%' : '150px',
                        template: "<span >{{dataItem[OperationReportCtrl.formatColumnName('Creator')]}}</span>",
                        scrollable: false,
                        search: true,
                        headerTemplate: "<span>Creator</span>"
                    }),
                {
                    field: tmxUtility.formatColumnName('UserName'),
                    title: "UserName",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template: "<span >{{dataItem[OperationReportCtrl.formatColumnName('UserName')]}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>User Name</span>"
                },
                {
                    field: tmxUtility.formatColumnName('FromState'),
                    title: "FromState",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template: "<span >{{dataItem[OperationReportCtrl.formatColumnName('FromState')]}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>From State</span>"
                },                
                {
                    field: tmxUtility.formatColumnName('ToState'),
                    title: "ToState",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template: "<span >{{dataItem[OperationReportCtrl.formatColumnName('ToState')]}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>To State</span>"
                },             
                {
                    field: tmxUtility.formatColumnName('statestartdate'),
                    title: "statestartdate",
                    type: "string",                                     
                    template: "{{OperationReportCtrl.formatDateTime(dataItem[OperationReportCtrl.formatColumnName('statestartdate')])}}",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>State Start Date</span>"
                },
                {
                    field: tmxUtility.formatColumnName('transitiontime'),
                    title: "transitiontime",
                    type: "string",                                   
                    template: "{{OperationReportCtrl.formatDateTime(dataItem[OperationReportCtrl.formatColumnName('transitiontime')])}}",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>State End Date</span>"
                },
                
                ( showComments &&  
                {
                    field: "Comments",
                    title: "Comments",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template: "<span >{{dataItem[OperationReportCtrl.formatColumnName('Comments')]}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>Comments</span>"
                }),
                {
                    field: tmxUtility.formatColumnName('TurnAroundTime'),
                    title: "TurnAroundTime",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template: "<span >{{dataItem[OperationReportCtrl.formatColumnName('TurnAroundTime')]}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>Turn Around Time</span>"
                },
                // {
                //     field: "TotalTurnAroundTime",
                //     title: "TotalTurnAroundTime",
                //     type: "text",
                //     // width: $mdMedia('gt-sm') ? '10%' : '150px',
                //     scrollable: false,
                //     search: true,
                //     headerTemplate: "<span>Total Turn Around Time</span>"
                // },
                {
                    field: tmxUtility.formatColumnName('transitionclassifier'),
                    title: "transitionclassifier",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template: "<span >{{dataItem[OperationReportCtrl.formatColumnName('transitionclassifier')]}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>Transition Classifier</span>"
                }
            ];


            return Report;

        }]);
})();